
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/impressum",
      function () {
        return require("private-next-pages/[lang]/impressum.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/impressum"])
      });
    }
  